import { Component } from "vuety";
import { IProductGroupItem } from "../../interfaces";
import { getRoot, findChild } from "../../root";
import Vue from "vue";
import { BaseView } from "../base";

const templateElement = "v-tmpl-groupbreadcrumb";

@Component({
	template: document.getElementById(templateElement)
		? "#" + templateElement
		: require("./breadcrumb.html"),
	mixins: [BaseView]
})
export class BreadcrumbView extends Vue {
	public get groups(): IProductGroupItem[] {
		let groupChain: IProductGroupItem[] = [];
		let thisGroup = findChild(this.currentGroup, getRoot().currentData.Groups);
		while (thisGroup) {
			groupChain.unshift(thisGroup);
			const parentCode = thisGroup.ParentCode;
			if (parentCode) {
				thisGroup = findChild(parentCode, getRoot().currentData.Groups);
			} else {
				thisGroup = undefined;
			}
		}
		return groupChain;
	}

	public getGroupName(group: IProductGroupItem) {
		if (
			this.options.allText &&
			this.options.rootGroup &&
			group.GroupCode.toLowerCase() === this.options.rootGroup.toLowerCase()
		) {
			return this.options.allText;
		}
		return group.GroupName;
	}

	public get groupDesc(): string {
		return getRoot().currentGroupObject(this.options).GroupDesc;
	}
}



// WEBPACK FOOTER //
// ./src/views/breadcrumb/breadcrumb.ts